var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnprocessedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.15639 3.70412C5.77001 2.31362 7.82574 1.54263 9.95578 1.52911C12.0858 1.51559 14.1512 2.26041 15.7823 3.63031C17.4135 5.00021 18.504 6.90581 18.8587 9.00614C19.2134 11.1065 18.8092 13.2645 17.7185 15.0941L17.263 14.8226C18.2893 13.1011 18.6696 11.0706 18.3358 9.09445C18.0021 7.11825 16.976 5.32529 15.4413 4.03636C13.9066 2.74743 11.9633 2.04663 9.95915 2.05935C7.95501 2.07208 6.02078 2.79749 4.50253 4.1058L4.15639 3.70412Z",
    stroke: "#737373"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.304419 7.27001L3.68908 8.45945L2.65216 5.7368L0.304419 7.27001Z",
    fill: "#737373"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.54147 7.56243C0.923549 9.34531 0.88352 11.2776 1.42708 13.0846C1.97063 14.8915 3.0701 16.4811 4.5691 17.6271C6.0681 18.7732 7.8903 19.4175 9.77654 19.4683C11.6628 19.5191 13.517 18.9738 15.0755 17.9101L14.6591 17.3C13.2289 18.2761 11.5274 18.7765 9.79642 18.7299C8.06549 18.6833 6.39332 18.0921 5.01774 17.0403C3.64216 15.9886 2.63323 14.53 2.13442 12.8718C1.63562 11.2136 1.67235 9.44041 2.2394 7.80432L1.54147 7.56243Z",
    stroke: "#737373"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9196 14.0454L19.154 15.5976L16.4956 16.7896L15.9196 14.0454Z",
    fill: "#737373"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71479 14.6307L4.97705 11.8929L5.8789 10.9911L7.71479 12.827L14.1565 6.36914L15.0584 7.27098L7.71479 14.6307Z",
    fill: "#737373",
    stroke: "#737373",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnprocessedIcon);
export default __webpack_public_path__ + "static/media/unprocessed-icon.a987be9cb21941b4547322172e4b28c7.svg";
export { ForwardRef as ReactComponent };